export default __webpack_public_path__ + "static/media/cb99bf4081f9a538d19358d130521bba.d805fa91.png";